import { __assign } from "tslib";
import { getDefaultRoleAssumerWithWebIdentity } from "@aws-sdk/client-sts";
import { fromWebToken as _fromWebToken, } from "@aws-sdk/credential-provider-web-identity";
export var fromWebToken = function (init) {
    var _a;
    return _fromWebToken(__assign(__assign({}, init), { roleAssumerWithWebIdentity: (_a = init.roleAssumerWithWebIdentity) !== null && _a !== void 0 ? _a : getDefaultRoleAssumerWithWebIdentity(init.clientConfig, init.clientPlugins) }));
};
